import type { deals } from '@prisma/client';
import api from '../api';
import type { OfferWithVehicle } from './offers';

export type Deal = deals;
export type DealWithOffers = deals & { offers: OfferWithVehicle[] };

const dealsService = {
  find: async (): Promise<DealWithOffers[]> => {
    const response = await api.get<DealWithOffers[]>('/deals');
    return response.data;
  },
  get: async (id: string): Promise<Deal> => {
    const response = await api.get<Deal>(`/deals/${id}`);
    return response.data;
  },
  /**
   * Creates an empty deal owned by the current user; offers are attached separately.
   * `searchZip`/`searchLat`/`searchLng` — the Cars page's search location, when it had one —
   * become the geo center for buyer-mode comp sourcing at OTD-request time (see
   * backend/src/outreach/comps.ts). Zip takes priority when both are present.
   */
  post: async (search?: {
    searchZip?: string;
    searchLat?: number;
    searchLng?: number;
  }): Promise<Deal> => {
    const response = await api.post<Deal>('/deals', search ?? {});
    return response.data;
  },
};

export default dealsService;
